import React from 'react';
import {createRoot} from 'react-dom/client';

import CssBaseline from '@mui/material/CssBaseline';
import {StyledEngineProvider, ThemeProvider} from '@mui/material/styles';
import AppWithAuth from './AppWithAuth';
import theme from './theme';
import {ToastContainer} from 'react-toastify';

const LOCAL_STORAGE_EXPECTED_VERSION = '1';
const LOCAL_STORAGE_VERSION_KEY = 'mybuildsimple-storage-version';
const localStorageVersion = localStorage.getItem(LOCAL_STORAGE_VERSION_KEY) || undefined;
if (!localStorageVersion || localStorageVersion !== LOCAL_STORAGE_EXPECTED_VERSION) {
  localStorage.removeItem('amplify-authenticator-authState');
  localStorage.removeItem('tenant-appClient');
}
localStorage.setItem(LOCAL_STORAGE_VERSION_KEY, LOCAL_STORAGE_EXPECTED_VERSION);

// Create root
const container = document.getElementById('root');
const root = createRoot(container);

// Render app
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline/>
        <ToastContainer/>
        <AppWithAuth/>
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>
);